import Immutable from "immutable";
import { createAlert } from "actions/alerts";
import { closeModal } from "actions/modal";
import { CallApiAction } from "actions/types";

export function updateBillingCustomer(payload: Immutable.Map<string, unknown>): CallApiAction {
  const { email, companyName, phoneNumber } = (
    payload.toJS() as {email: string; companyName: string; phoneNumber: string}
  );

  return {
    CALL_API: {
      method: "patch",
      endpoint: "/billings/customer/",
      payload: {
        email,
        company_name: companyName,
        phone_number: phoneNumber
      },
      types: ["UPDATE_BILLING_CUSTOMER_REQUEST", "UPDATE_BILLING_CUSTOMER_SUCCESS", "UPDATE_BILLING_CUSTOMER_FAILURE"],
      args: {
        email,
        companyName,
        phoneNumber
      },
      dispatchCallbacks: [
        {
          request: createAlert,
          fireOnStatus: "success",
          args: {
            message: "Customer information successfully updated.",
            alertType: "success"
          }
        },
        {
          request: createAlert,
          fireOnStatus: "error"
        },
        {
          request: closeModal,
          fireOnStatus: "success"
        }
      ]
    }
  };
}
